import { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { authFetch } from '../../utils/authFetch';

const VisualizarPrestServico = () => {    
    const navigate = useNavigate();
    const { id } = useParams();

    const [name, setName] = useState('');
    const [company, setCompany] = useState('');
    const [phone, setPhone] = useState('');
    const [serviceType, setServiceType] = useState('');

    useEffect(() => {
        const fetchPrestServico = async () => {
            try {
                const response = await authFetch(`${"service-provider"}/${id}`, {
                    method: 'GET',                    
                });

                if (!response.ok) throw new Error('Erro ao buscar prestador de serviço');

                const data = await response.json();
                setName(data.name);
                setCompany(data.company);
                setPhone(data.phone);
                setServiceType(data.serviceType);
            } catch (error) {
                console.error(error);
                alert(error.message);
                navigate('/PrestServicos');
            }
        };

        fetchPrestServico();
    }, [id]);

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Visualizar Prestador de Serviço</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
                            <fieldset className="col-md-6">
                                <div className="mb-3">
                                    <label>Nome</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={name}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label>Empresa</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={company}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label>Telefone</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={phone}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label>Tipo de Serviço</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={serviceType}
                                        readOnly
                                    />
                                </div>
                                <div className="card-footer" style={{ paddingLeft: "0" }}>
                                    <Link to={'/PrestServicos'} className="btn btn-info btn-sm">Voltar</Link>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VisualizarPrestServico;
